module.exports = __webpack_public_path__ + "static/media/quality_control-desktop.e3a1fdcf.png";